import { gql } from "apollo-boost";

export const APPLY_OFFER_CODE_MUTATION = gql`
  mutation applyOfferCode($bookingId: ID!, $offerCode: String) {
    applyOfferCode(bookingId: $bookingId, offerCode: $offerCode) {
      id
      status
      appliedOffers {
        offerId
        offerName
        code
        discountAmount
      }
      paymentDetails {
        rentalAmount
        startDate
        endDate
        taxAmount
        insuranceAmount
        discountAmount
        offerDiscountAmount
        addonsAmount
        totalPayableAmount
        rentalTime
        isProrated
        standardBillingDays
        proratedBillingDays
      }
    }
  }
`;

export const APPLY_OFFER_CODE = gql`
  mutation consumerApplyOfferCode($bookingId: ID!, $offerCode: String) {
    consumerApplyOfferCode(bookingId: $bookingId, offerCode: $offerCode) {
      id
      discount {
        appliedBy
        appliedDate
        isPercent
        code
        amount
      }
      appliedOffers {
        offerId
        offerName
        code
        discountAmount
      }
      paymentDetails {
        rentalAmount
        taxAmount
        insuranceAmount
        discountAmount
        offerDiscountAmount
        addonsAmount
        totalPayableAmount
      }
    }
  }
`;
